import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { MaintenanceType, PagedResult } from 'app/core/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceTypeApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
    private querify: QuerifyService,
  ) {}

  search(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);

    return this.apollo
      .query({
        query: this.queries.maintenanceTypesPaginated(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['maintenanceTypes'];
        })
      );
  }

  async searchOne(maintenanceTypeId: string): Promise<MaintenanceType> {
    return this.apollo.query({
      query: this.queries.searchMaintenanceType(),
      variables: { id: maintenanceTypeId }
    }).toPromise()
      .then(({ data }) => {
        return data['maintenanceType'];
      });
  }

}
